import { useLocaleHead } from '#i18n'

/**
 * 输出 hreflang、html lang/dir 等文档级 SEO / a11y 元数据。
 * Dashboard 页面用 `<DashboardI18nHead />`；default layout 在 setup 中直接调用。
 *
 * @param {{ englishOnly?: boolean }} [options]
 * `englishOnly`: 博客等仅英文页 — html lang 固定 en，且不输出小语种 alternate。
 */
export function useI18nDocumentHead(options = {}) {
  const englishOnly = Boolean(options.englishOnly)

  const i18nHead = useLocaleHead({
    dir: true,
    lang: true,
    seo: true,
    key: 'id',
  })

  useHead({
    htmlAttrs: {
      lang: computed(() =>
        englishOnly ? 'en' : i18nHead.value.htmlAttrs?.lang,
      ),
      dir: computed(() =>
        englishOnly ? 'ltr' : i18nHead.value.htmlAttrs?.dir,
      ),
    },
    link: computed(() => {
      const links = i18nHead.value.link ?? []
      if (!englishOnly) return links
      return links.filter((link) => {
        if (link?.rel !== 'alternate') return true
        const hreflang = String(link.hreflang || '').toLowerCase()
        return hreflang === 'en' || hreflang === 'x-default'
      })
    }),
    meta: computed(() => i18nHead.value.meta ?? []),
  })
}
